<template>
   <div class="layout-px-spacing" v-if="
        this.$can('admin') ||
        this.$can('office') ||
        this.$can('technik-manager') ||
        this.$can('obchodnik-manager') ||
        this.$can('rola-pobocka') ||
        this.$can('skladnik') ||
        this.$can('kurier') ||
        this.$can('infolinka') ||
        this.$can('technik')
   ">
      <portal to="breadcrumb">
         <ul class="navbar-nav flex-row">
            <li>
               <div class="page-header">
                  <nav class="breadcrumb-one" aria-label="breadcrumb">
                     <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="javascript:;">{{ $t("users") }}</a></li>
                        <li class="breadcrumb-item active" aria-current="page"><span>{{ $t("profile") }}</span></li>
                     </ol>
                  </nav>
               </div>
            </li>
         </ul>
      </portal>

      <div class="row layout-spacing">
         <div class="col-lg-12 layout-top-spacing">
            <div class="panel">
               <div class="panel-heading">
                  <div class="row">
                     <div class="col-12">
                        <h3>{{ $t("create_new_reciep") }}</h3>
                     </div>
                  </div>
               </div>

               <div class="panel-body">
                  <b-form @submit.prevent="submitForm" ref="form">
                     <div class="row align-items-center mb-md-4">
                        <div class="col-12 mt-0">
                           <b-form-row class="over-1">
                              <b-form-group class="col-md-6" :label="$t('supplier')">
                                 <b-form-input :state="validateState('other_user_name')"
                                               v-model="form.other_user_name" type="text"
                                               placeholder=""></b-form-input>
                              </b-form-group>
                              <b-form-group class="col-md-6" :label="$t('recipient')">
                                 <b-form-input v-if="form.to_user_id" :state="validateState('to_user_id')" readonly
                                               v-model="form.to_user_id.pouzivatel.name" type="text"
                                               placeholder=""></b-form-input>
                                 <b-form-invalid-feedback>{{ $t("required_field") }}</b-form-invalid-feedback>
                              </b-form-group>
                           </b-form-row>
                           <b-form-row>
                              <b-form-group class="col-md-12" :label="$t('products')">
                                 <div class="form-repeater w-100 custom-table">
                                    <table class="table table-responsive-detail">
                                       <thead>
                                          <tr>
                                             <th style="width: 30%;min-width: 200px">{{ $t("name") }}</th>
                                             <th style="width: 30%;min-width: 200px">{{ $t("count") }}</th>
                                             <th style="width: 30%;min-width: 200px">{{ $t("note") }}</th>
                                             <th class="text-center">{{ $t("delete") }}</th>
                                          </tr>
                                       </thead>
                                       <tbody class="form-repeater">
                                          <tr v-for="(row, index) in form.rows" :key="index" class="row-product-item">
                                             <td>
                                                <div v-if="row.id != null" class="row-product-item-image-box">
                                                   <img v-if="row.attachments[0]" :src="url + '/' +  row.attachments[0].file_path" @click="() => showRowImg(index)" loading="lazy">
                                                   <svg v-else
                                                        viewBox="0 0 24 24" width="24" height="24"
                                                        stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"
                                                        stroke-linejoin="round" class="css-i6dzq1">
                                                      <path
                                                        d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                                                      </path>
                                                      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                                      <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                                   </svg>
                                                   <div class="d-flex align-items-center">
                                                      <h6 class="mb-0 ml-2">{{ row.name }}</h6>
                                                   </div>
                                                </div>
                                                <div v-else class="row-product-item-image-box">
                                                   <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1" style="fill: #515365; min-width: 3.2rem;">
                                                      <path
                                                        d="M2.75,21.93c-.18,0-.37-.05-.53-.15-.47-.29-.61-.91-.31-1.38L14.48.47c.29-.47.91-.61,1.38-.31.47.29.61.91.31,1.38L3.59,21.46c-.19.3-.51.47-.85.47Z"
                                                        stroke-width="0" />
                                                      <path
                                                        d="M1.5,17.94l.68.39,1.07-1.69-.75-.43c-.31-.18-.5-.51-.5-.86v-7.46l4.97,2.87,1.07-1.69-5-2.89,6.46-3.69c.15-.09.33-.13.5-.13s.35.05.5.14l1.24.71,1.07-1.69-1.31-.75c-.93-.53-2.08-.54-3,0L1.5,4.74c-.35.2-.62.48-.86.79-.09.07-.17.16-.24.27-.04.07-.05.14-.07.21-.2.41-.33.86-.33,1.33v8c0,1.07.58,2.06,1.5,2.6Z"
                                                        stroke-width="0" />
                                                      <path
                                                        d="M19.6,5.8c-.07-.11-.15-.21-.25-.28-.23-.3-.51-.58-.85-.77l-2.52-1.44-1.07,1.69,2.05,1.17-4.4,2.54-3.56,5.65v5.56l-2.58-1.47-1.07,1.69,3.15,1.8c.32.18.66.28,1.01.34.15.09.31.15.49.15s.34-.06.49-.15c.35-.06.69-.15,1.01-.34l7-4c.92-.53,1.5-1.53,1.5-2.59h0V7.34c0-.47-.13-.91-.33-1.32-.02-.07-.03-.15-.07-.22ZM18,15.34c0,.36-.19.69-.5.86l-6.5,3.72v-7.99l7-4.05v7.46Z"
                                                        stroke-width="0" />
                                                   </svg>
                                                   <b-form-input v-model="row.name" type="text" :placeholder="$t('enter_item_name')" class="ml-1"></b-form-input>
                                                </div>
                                             </td>
                                             <td>
                                                <b-input-group class="">
                                                   <template #append>
                                                      <b-input-group-text><strong v-if="row.unit" class="">{{ row.unit.name }}</strong></b-input-group-text>
                                                   </template>
                                                   <b-form-input v-model="row.quantity" type="number" min="0" placeholder=""></b-form-input>
                                                </b-input-group>
                                                <b-form-invalid-feedback>{{ $t("required_field") }}</b-form-invalid-feedback>
                                             </td>
                                             <td>
                                                <b-form-input v-model="row.note_custom" type="text" placeholder=""></b-form-input>
                                             </td>
                                             <td class="text-center align-middle">
                                                <b-button variant="outline-danger" @click="removeRow(index)">
                                                   <svg
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="24"
                                                     height="24"
                                                     viewBox="0 0 24 24"
                                                     fill="none"
                                                     stroke="currentColor"
                                                     stroke-width="2"
                                                     stroke-linecap="round"
                                                     stroke-linejoin="round"
                                                     class="feather feather-trash-2"
                                                   >
                                                      <polyline points="3 6 5 6 21 6"></polyline>
                                                      <path
                                                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                      <line x1="10" y1="11" x2="10" y2="17"></line>
                                                      <line x1="14" y1="11" x2="14" y2="17"></line>
                                                   </svg>
                                                </b-button>
                                             </td>
                                          </tr>

                                          <tr class="text-md-center">
                                             <td colspan="6">
                                                <b-button variant="outline-dark" @click="show_items_modal">{{ $t("add_row") }}</b-button>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </b-form-group>
                           </b-form-row>
                           <b-form-row>
                              <b-form-group class="col-md-12" :label="$t('global_note')">
                                 <b-form-textarea id="textarea" v-model="$v.form.note.$model" :placeholder="$t('note')"
                                                  rows="4"></b-form-textarea>
                              </b-form-group>
                           </b-form-row>
                        </div>
                        <vue-easy-lightbox :visible="visibleRowImage" :imgs="lightboxRowImages" :index="lightboxRowIndex" @hide="handleRowHide" />
                     </div>
                     <div class="row">
                        <div class="col-12 text-right">
                           <b-button @click="$router.go(-1)" variant="cancel" class="mt-3">{{ $t("cancel") }}</b-button>
                           <b-button type="submit" variant="default" class="mt-3 ml-2">{{ $t("create") }}</b-button>
                        </div>
                     </div>
                  </b-form>
               </div>
            </div>
            <b-modal dialog-class="modal-fullscreen" centered id="addProductModal" :static="true" :title="$t('choose_product')" size="xl" no-close-on-esc>
               <b-form-input type="text" v-model="itemSearch" :placeholder="$t('search_product')"></b-form-input>

               <div class="d-flex flex-wrap align-items-center mt-2">
                  <div v-for="item in categories" :key="item.id" class="mr-3">
                     <b-form-checkbox v-model="selectedCategories" :value="item.id">{{ item.name }}</b-form-checkbox>
                  </div>
                  <h6 class="reset-category-link mb-0" @click="resetFilters" v-if="shouldShowReset">{{ $t("reset") }}</h6>
               </div>

               <div class="row mt-3">
                  <div v-for="(item, index) in filteredItems" :key="item.id" class="col-md-6">
                     <div :class="['product-card', isSelected(item) ? 'product-card-active' : '']">
                        <div class="product-card-box grow d-flex align-items-center flex-wrap justify-content-between px-2 py-2">
                           <div class="d-flex align-items-center gap-3">
                              <div class="product-card-item">
                                 <img v-if="item.attachments?.[0]" :src="url + '/' + item.attachments[0].file_path" @click="() => showImg(index)" />
                                 <svg v-else
                                      v-b-tooltip.hover
                                      viewBox="0 0 24 24" width="24" height="24"
                                      stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"
                                      stroke-linejoin="round" class="css-i6dzq1">
                                    <path
                                      d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                                    </path>
                                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                 </svg>
                              </div>
                              <h6 class="mb-0 ml-2">{{ item.name }}</h6>
                           </div>
                           <div class="d-flex align-items-center">
                              <button class="btn btn-outline-dark" @click="toggleItem(item)" v-if="!isSelected(item)">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                      class="feather feather-plus-circle">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="8" x2="12" y2="16"></line>
                                    <line x1="8" y1="12" x2="16" y2="12"></line>
                                 </svg>
                              </button>
                              <button class="btn btn-outline-danger" @click="toggleItem(item)" v-else>
                                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2" data-v-5522efca="">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                 </svg>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <template #modal-footer>
                  <b-button variant="primary" data-dismiss="modal" @click="confirmSelectedItems">{{ $t("save") }}</b-button>
                  <b-button variant="cancel" data-dismiss="modal" @click="cancel_item">{{ $t("cancel") }}</b-button>
               </template>

               <vue-easy-lightbox :visible="visible" :imgs="lightboxImages" :index="lightboxIndex" @hide="handleHide" />


               <objednavka-kosik :items="selectedItemsFromModal" @remove="removeItemFromModal" @clear="clearAllSelectedItems" />
            </b-modal>

         </div>
      </div>
   </div>
   <div class="layout-px-spacing d-flex align-items-center justify-content-center" v-else>
      <div class="row layout-top-spacing">
         <div class="col-12">
            <h4 class="text-center px-3">{{ $t("not_allowed") }}</h4>
         </div>
      </div>
   </div>
</template>

<script>
   import { validationMixin } from "vuelidate";
   import { required } from "vuelidate/lib/validators";
   import router from "@/router";
   import { urlMixin } from "@/mixins/url";
   import ObjednavkaKosik from "@/views/objednavky/objednavka-kosik.vue";

   export default {
      name: "new",
      mixins: [validationMixin, urlMixin],
      components: { ObjednavkaKosik },
      validations: {
         form: {
            name: {},
            other_user_name: {
               required
            },
            to_user_id: {
               required
            },
            note: {},
            rows: {
               $each: {
                  id: {
                     required
                  },
                  quantity: {
                     required
                  }
               }
            }
         }
      },
      data() {
         return {
            type: "",
            form: {
               name: "",
               other_user_name: null,
               to_user_id: null,
               note: "",
               // rows: [{ id: null, quantity: "", note: "", note_custom: "" }]
               rows: []
            },
            itemSearch: "",
            selectedCategories: [],
            selectedItemsFromModal: [],
            categories: [],
            visible: false,
            lightboxImages: [],
            lightboxIndex: 0,
            visibleRowImage: false,
            lightboxRowImages: [],
            lightboxRowIndex: 0
         };
      },
      created() {
         this.type = router.currentRoute.params.type;
         this.$axios.get("user")
           .then(response => {
              this.form.to_user_id = response.data;
           });
         // this.$store.dispatch("user/getUsers");
         this.$store.dispatch("item/getItems", { all: 1 });
         this.$axios.get("item_categories").then(res => {
            this.categories = res.data;
            this.selectedCategories = res.data.map((cat) => cat.id);
         });
      },
      computed: {
         // users() {
         //   return this.$store.state.user.users;
         // },
         items() {
            return this.$store.state.item.items;
         },
         filteredItems() {
            const normalize = str => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            const search = normalize(this.itemSearch);

            return this.items.filter(item => {
               const inSearch = normalize(item.name).includes(search);
               const inCategory = this.selectedCategories.length === 0 || this.selectedCategories.includes(item.category.id);
               return inSearch && inCategory;
            });
         },
         shouldShowReset() {
            return this.itemSearch.trim() !== "" || this.selectedCategories.length !== this.categories.length;
         }

      },
      methods: {
         removeRow(index) {
            this.form.rows.splice(index, 1);
         },
         validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
         },
         submitForm() {
            // this.form.rows.forEach(function (value) {
            //   if (value.id == null || value.quantity == null) {
            //     this.errors.push('Item is not correct');
            //   }
            // })


            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
               console.log(this.form);

               this.$toast.error(this.$t("missing_credentials"));
               return;
            }

            let data = {
               name: this.form.name,
               other_user_name: this.form.other_user_name,
               to_user_id: this.form.to_user_id.pouzivatel.id,
               note: this.form.note,
               type: "SELF_IN"
            };

            let formData = new FormData();

            for (let key in data) {
               formData.append(key, data[key]);
            }


            this.form.rows.forEach(function(value, index) {
               // if (value.id !== null && value.id !== undefined) {
               formData.append("items[" + index + "][id]", value.id);// you have to add array symbol after the key name
               formData.append("items[" + index + "][quantity]", value.quantity);// you have to add array symbol after the key name
               formData.append("items[" + index + "][note]", value.note_custom);// you have to add array symbol after the key name
               // }
            });
            // Display the key/value pairs
            // for (var pair of formData.entries()) {
            //   console.log(pair[0] + ', ' + pair[1]);
            // }

            this.$axios.post("movements", formData).then((response) => {
               console.log(response);
               this.$toast.success(response.data.message);
               this.$router.go(- 1);

            }).catch(error => {
               this.$toast.error(error.response.data.message);
            });
         },
         show_items_modal() {
            this.selectedItemsFromModal = this.form.rows
              .filter(r => r.id !== null)
              .map(r => {
                 const item = this.items.find(i => i.id === r.id);
                 return item ? item : null;
              })
              .filter(i => i); // odstráni null hodnoty
            this.$bvModal.show("addProductModal");
         },
         cancel_item() {
            this.selectedItemsFromModal = [];
            this.resetFilters();
            this.$bvModal.hide("addProductModal");
         },
         confirmSelectedItems() {
            const selectedIds = this.selectedItemsFromModal.map(i => i.id);
            const updatedRows = [];

            this.form.rows.forEach((row) => {
               if (row.id === null) {
                  updatedRows.push(row);
               } else if (selectedIds.includes(row.id)) {
                  const selected = this.selectedItemsFromModal.find(i => i.id === row.id);
                  updatedRows.push({
                     id: selected.id,
                     name: selected.name,
                     quantity: row.quantity || "",
                     note_custom: row.note_custom || "",
                     unit: selected.unit,
                     attachments: selected.attachments || []
                  });
               }
            });

            this.selectedItemsFromModal.forEach((item) => {
               const exists = updatedRows.some(r => r.id === item.id);
               if (!exists) {
                  updatedRows.push({
                     id: item.id,
                     name: item.name,
                     quantity: "",
                     note_custom: "",
                     unit: item.unit,
                     attachments: item.attachments || []
                  });
               }
            });

            this.form.rows = updatedRows;
            this.resetFilters();
            this.$bvModal.hide("addProductModal");
         },
         toggleItem(item) {
            const index = this.selectedItemsFromModal.findIndex(i => i.id === item.id);
            if (index === - 1) {
               this.selectedItemsFromModal.push(item);
            } else {
               this.selectedItemsFromModal.splice(index, 1);
            }
         },
         isSelected(item) {
            return this.selectedItemsFromModal.some(i => i.id === item.id);
         },
         removeItemFromModal(item) {
            this.selectedItemsFromModal = this.selectedItemsFromModal.filter(i => i.id !== item.id);
         },
         clearAllSelectedItems() {
            this.selectedItemsFromModal = [];
         },
         resetFilters() {
            this.selectedCategories = this.categories.map((cat) => cat.id);
            this.itemSearch = "";
         },
         showRowImg(index) {
            this.lightboxRowImages = this.form.rows
              .filter(row => row.id && row.attachments)
              .flatMap(row => row.attachments.map(att => this.url + "/" + att.file_path));

            const clickedImage = this.form.rows[index]?.attachments?.[0];

            if (clickedImage) {
               const fullPath = this.url + "/" + clickedImage.file_path;
               this.lightboxRowIndex = this.lightboxRowImages.findIndex(img => img === fullPath);
            } else {
               this.lightboxRowIndex = 0;
            }

            this.visibleRowImage = true;
         },
         showImg(itemIndex) {
            this.lightboxImages = this.items
              .flatMap(item => item.attachments.map(att => this.url + "/" + att.file_path));

            const clickedImage = this.items[itemIndex]?.attachments?.[0];

            if (clickedImage) {
               const fullPath = this.url + "/" + clickedImage.file_path;
               this.lightboxIndex = this.lightboxImages.findIndex(img => img === fullPath);
            } else {
               this.lightboxIndex = 0;
            }

            this.visible = true;
         },

         handleHide() {
            this.visible = false;
         },
         handleRowHide() {
            this.visibleRowImage = false;
         }
      }
   };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
   @import '@/assets/sass/global/table.scss';
</style>
